import * as React from 'react'
import { SVGProps } from 'react'
export const TrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="#292D32"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M15.633 4.794a84.752 84.752 0 0 0-8.35-.417c-1.65 0-3.3.083-4.95.25l-1.7.167M5.219 3.952l.183-1.092c.133-.792.233-1.383 1.642-1.383h2.183c1.408 0 1.517.625 1.642 1.391l.183 1.084M10.805 18.142h-5.35c-2.325 0-2.4-1.016-2.491-2.325l-.542-8.391M13.838 7.426l-.541 8.391"
    />
  </svg>
)
